import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppService } from '../services/app.service';
import { ApiUsuarioService } from '../services/api-usuario.service';

@Injectable({
    providedIn: 'root'
})
export class EmbeddedGuard {

    private readonly _appService = inject(AppService);
    private readonly _apiUsuarioService = inject(ApiUsuarioService);
    private readonly _router = inject(Router);

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean | UrlTree {
        const credenciais = this._apiUsuarioService.getCredenciais();

        if (credenciais && credenciais.usuarioQueLogou) {
            return true;
        }

        if (this._appService.isEmbeddedMode()) {
            const isCotacoes = state.url.includes('cotacoes');
            return this._router.createUrlTree([isCotacoes ? '/loading' : '/pagina-indisponivel']);
        }
        return true;
    }
}
